module.exports = __webpack_public_path__ + "54ffab39be34cf313c99b50a9d6b6d22.ttf";